import { useNavigate } from "react-router-dom";
import { imgSrc } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileEdit, Pencil, Trash2 } from "lucide-react";

export const DraftsCard = ({ drafts, onDelete }) => {
  const navigate = useNavigate();
  if (!drafts.length) return null;
  return (
    <Card data-testid="dashboard-drafts-card" className="rounded-2xl">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <FileEdit className="h-4 w-4" /> Campaign drafts ({drafts.length})
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {drafts.map((d) => (
          <div key={d.id} data-testid="dashboard-draft-item" className="flex items-center gap-3 rounded-xl border bg-card p-3">
            <div className="h-14 w-11 shrink-0 overflow-hidden rounded-lg bg-muted">
              {imgSrc(d.model_image) && <img src={imgSrc(d.model_image)} alt="" className="h-full w-full object-cover" />}
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold">{d.job?.title || "Untitled campaign"}</p>
              <p className="truncate text-xs text-muted-foreground">
                {d.model_name} · {d.screening_id ? "screened" : "not screened yet"} · saved {new Date(d.updated_at).toLocaleDateString()}
              </p>
            </div>
            <div className="flex shrink-0 gap-2">
              <Button data-testid="dashboard-draft-resume-button" size="sm" className="h-8 rounded-lg text-xs"
                onClick={() => navigate(`/book/${d.model_profile_id}?draft=${d.id}`)}>
                <Pencil className="mr-1 h-3 w-3" /> Resume
              </Button>
              <Button data-testid="dashboard-draft-delete-button" size="sm" variant="ghost" className="h-8 rounded-lg text-xs text-destructive"
                onClick={() => onDelete(d.id)}>
                <Trash2 className="h-3.5 w-3.5" />
              </Button>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
